import { useDispatch } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";

import { showErrorToast, showSuccessToast } from "app/actions/toast_actions";
import { renderErrorToast } from "app/pages/sales-intelligence/common-components/ErrorToast/ErrorToast";
import { SuccessToast } from "app/pages/sales-intelligence/common-components/SuccessToast/SuccessToast";

const TOAST_DURATION_MS = 4000;

export const useEmployeeProfileToasts = () => {
    const dispatch = useDispatch();
    const { translate } = useTranslate();

    const showSuccess = (translationKey: string) => {
        dispatch(showSuccessToast(<SuccessToast content={translate(translationKey)} />, Date.now(), TOAST_DURATION_MS));
    };

    /** For server-provided text that has no translation key, e.g. a validation reason returned on a 400. */
    const showErrorMessage = (message: string) => {
        dispatch(
            showErrorToast(
                renderErrorToast({
                    content: message,
                    minWidth: "auto",
                }),
            ),
        );
    };

    const showError = (translationKey = "si.common.toast.error", params?: Record<string, number | string>) => {
        showErrorMessage(translate(translationKey, params));
    };

    return { showSuccess, showError, showErrorMessage };
};
